import React from "react";
import SwitchPoint from '../Uswitch/switchpoint'

export default function SwitchPanel(ucs) {
  console.log('Switch Panel props',ucs);
  const showMyThings = ucs.switch_info.ucs.switches;
  console.log('showthing switches',showMyThings);
  //console.log('vars/props in',JSON.stringify(ucs))
  //console.log('from the dataloader inside switches',ucs.allthings);
  //var var2 = ucs.ucs.switches;  // was allthings.things...trying switch
  //console.log('the switch list-->',var2,"<---") 
  //console.log('switch list allthings.things stringified->',JSON.stringify(var2),"<---") 

  return (
    <> 
    <div style={{ padding: 1 }}>
    <ul>
      {showMyThings?.map((a_switch, index) => (
          <li key={a_switch.switch_id.S} id="list_of_switches" >
            {index+1}
             <SwitchPoint switch_info={{si:a_switch, counter:index+1}} />
          </li>
        ))}
         </ul>
    </div>
  </>
  ) ;
}
